import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 480 480",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M72 310 40 436l233-3 109 46 97-52-18-392-90-21-81 25-63-38L30 64 1 119Z",
			fill: "#f2f1ed"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#5279cc",
			children: /* @__PURE__ */ _jsx("path", { d: "m273 433 109 46-8-171 68-127-124-11-66 98zM162 171l97-60-38-36-98 53-51 182Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m123 128 39 43 90 97 190-87-124-11-59-59-38-36z",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m273 433 109 46 97-52-105-119Z",
			fill: "#fff",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m318 170 124 11 19-146-90-21ZM72 310l51-182-122-9ZM374 308l68-127-190 87ZM259 111l31-72-63-38-6 74ZM252 268l-90-97-90 139Z",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1 119 122 9 98-53Z",
			fillOpacity: .6
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "#000",
			strokeWidth: .3,
			children: [
				/* @__PURE__ */ _jsx("path", { d: "m273 433-21-165-180 42 90-139 97-60-38-36-98 53 39 43" }),
				/* @__PURE__ */ _jsx("path", { d: "m72 310 51-182-122-9 220-44 6-74M290 39l-31 72 59 59-66 98 190-87-124-11 53-156" }),
				/* @__PURE__ */ _jsx("path", { d: "m461 35-19 146-68 127-122-40M273 433l101-125 8 171M374 308l105 119M162 171l90 97" })
			]
		}),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "m40 436 32-126L1 119l27-54L227 1l63 38 81-25 90 21 18 392-97 52-109-46Z",
			fill: "none",
			stroke: "#4d4d4d"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M250 43c100 102-39 101-35 244 0 37 39 74 22 137",
			fill: "none",
			stroke: "#fe3737",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}) })
	]
});
export default SvgLogo;
